import { FontGrid } from './font-grid'

export function FontPickerPage() {
	return (
		<div className="ring ring-grey-100 rounded-sm h-full">
			<FontGrid mode="page" />
		</div>
	)
}
